/** @hidden */
export default {
  create: 0,
  tick: 0,
  component: 0,
  draw: 0,
  fps: 0,
};
